import { css } from "@emotion/css";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import colors from "src/utils/colors";
import tw from "src/utils/tw";

interface Props {
  type?: string;
  className?: string;
  bgColor?: string;
  borderBottom?: boolean;
  borderTop?: boolean;
  noPadding?: boolean;
  children: ReactNode;
}

export default function Section(props: Props) {
  const location = useLocation();

  const styles = css([
    { margin: "auto" },
    props.noPadding ? { padding: 0 } : { padding: "1rem 0" },
    location.pathname === "/admin/settings" && listStyles,
    props.bgColor
      ? { background: props.bgColor }
      : { background: "transparent" },
    props.borderBottom && borderBottomStyles,
    props.borderTop && borderTopStyles,
  ]);

  return (
    <section className={tw(styles, props.className)}>{props.children}</section>
  );
}

const listStyles = css`
  background: ${colors.bgGray};
`;

const borderBottomStyles = css`
  border-bottom: 1px solid ${colors.borderGray};
`;

const borderTopStyles = css`
  border-top: 1px solid ${colors.borderGray};
`;
